import type { SVGProps } from 'react';

const SvgViewupPlusColor = (props: SVGProps<SVGSVGElement>) => (
  <svg
    fill='none'
    height='1em'
    viewBox='0 0 24 24'
    width='1em'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M16.225 2H7.878C4.252 2 2.09 4.17 2.09 7.81v8.37c0 3.65 2.162 5.82 5.788 5.82h8.337c3.626 0 5.788-2.17 5.788-5.81V7.81C22.013 4.17 19.85 2 16.225 2Z'
      fill='#EFF0F3'
    />
    <circle cx={17.667} cy={6.333} fill='#923CBA' r={1.333} />
    <path
      clipRule='evenodd'
      d='M12 7.667a1 1 0 0 1 1 1v6.666a1 1 0 1 1-2 0V8.667a1 1 0 0 1 1-1Z'
      fill='#923CBA'
      fillRule='evenodd'
    />
    <path
      clipRule='evenodd'
      d='M7.667 12a1 1 0 0 1 1-1h6.666a1 1 0 0 1 0 2H8.666a1 1 0 0 1-1-1Z'
      fill='#923CBA'
      fillRule='evenodd'
    />
  </svg>
);
export default SvgViewupPlusColor;
